import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
var NavigationIcon = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(NavigationIcon, _React$Component);
    function NavigationIcon(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            navOpen: false
        };
        return _this;
    }
    var _proto = NavigationIcon.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.watchWindowResize();
    };
    _proto.watchWindowResize = function watchWindowResize() {
        var _this2 = this;
        window.addEventListener("resize", function () {
            return _this2.setState({
                navOpen: false
            });
        });
    };
    _proto.onNavClick = function onNavClick() {
        var _this3 = this;
        this.setState({
            navOpen: !this.state.navOpen
        }, function () {
            return _this3.props.onNavClick && _this3.props.onNavClick();
        });
    };
    _proto.render = function render() {
        var _this4 = this;
        return /*#__PURE__*/ React.createElement("div", {
            className: "nav-icon " + (this.state.navOpen && "open"),
            onClick: function onClick() {
                return _this4.onNavClick();
            }
        }, /*#__PURE__*/ React.createElement("span", null), /*#__PURE__*/ React.createElement("span", null), /*#__PURE__*/ React.createElement("span", null));
    };
    return NavigationIcon;
}(React.Component);
export { NavigationIcon as default };
